var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Fetcher from "./Shared/FetchService";
import FromEmailAddressService from "./FromEmailAddress.service";
import FromEmailAddressDomainService from "../Domain/FromEmailAddress/FromEmailAddress.service";
import MessageDomainService from "../Domain/Message/Message.service";
const advisorUrl = "/aviso/advisor/";
const scheduledMessageUrl = "/aviso/scheduledMessage/";
const filterUrl = "/aviso/filter/";
const templateMessageUrl = "/aviso/myMessageTemplate/";
const baseUrl = "/aviso/message";
const SEND_TO_SELECTED_RECIPIENTS_FROM_THREAD_ID = 0;
const SEND_TO_RECIPIENTS_IN_LIST_MESSAGE_TYPE = 1;
const SEND_TO_FILTER_MESSAGE_TYPE = 18;
export const getPersonCampaignFromAddressFromPerson = (person) => ({
    type: "Person",
    id: person.personId,
    label: `${person.fullName} <${person.emailAddress}>`,
    value: person,
});
export const getFromEmailAddressCampaignFromAddressFromFromEmailAddress = (address) => ({
    type: "FromEmailAddress",
    id: address.id.toString(),
    label: FromEmailAddressDomainService.toString(address),
    value: address,
});
export default class MessageService {
    static getMessageTypes() {
        return Fetcher.getSingleArrayResponse(baseUrl + "/getMessageTypes");
    }
    static getAdvisorInbox(options = {}) {
        // @ts-expect-error - TS2322 - Type 'Promise<PagedResult<MessageListItemDto[]>>' is not assignable to type 'Promise<PagedResponse<MessageListItemDto[]>>'.
        return Fetcher.getPagedResponse(advisorUrl + "inbox", {
            offset: options.offset || 0,
            onlyUnread: options.unread || false,
            searchText: options.query || "",
            maxRows: options.max || 10,
        });
    }
    static getAdvisorSentMessages(options = {}) {
        // @ts-expect-error - TS2322 - Type 'Promise<PagedResult<MessageListItemDto[]>>' is not assignable to type 'Promise<PagedResponse<MessageListItemDto[]>>'.
        return Fetcher.getPagedResponse(advisorUrl + "sent", {
            offset: options.offset || 0,
            searchText: options.query || "",
            maxRows: options.max || 10,
        });
    }
    static getMessageTemplates(options = {}) {
        // @ts-expect-error - TS2322 - Type 'Promise<PagedResult<MessageTemplate[]>>' is not assignable to type 'Promise<PagedResponse<MessageTemplate[]>>'.
        return Fetcher.getPagedResponse(templateMessageUrl + "search", {
            offset: options.offset || 0,
            maxRows: options.max || 10,
            term: options.query || "",
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'request' implicitly has an 'any' type.
    static saveMessageTemplate(request) {
        return Fetcher.postSingleResponse(templateMessageUrl + "save", request);
    }
    // @ts-expect-error - TS7006 - Parameter 'request' implicitly has an 'any' type.
    static sendAndTestMessageTemplate(request) {
        return Fetcher.postSingleResponse(templateMessageUrl + "sendMessageTemplateTestMessage", request);
    }
    // @ts-expect-error - TS7006 - Parameter 'request' implicitly has an 'any' type.
    static updateMessageTemplate(request) {
        return Fetcher.postSingleResponse(templateMessageUrl + "update", request);
    }
    static getMessageTemplateById(id) {
        return Fetcher.getSingleResponse(templateMessageUrl + "getById", { id });
    }
    static deleteMessageTemplate(id) {
        return Fetcher.deleteSingleResponse(templateMessageUrl + "ajaxDelete", {
            id,
        });
    }
    static getScheduledMessage() {
        return Fetcher.getSingleArrayResponse(scheduledMessageUrl + "myScheduledMessages");
    }
    static getScheduledMessageById(id) {
        return Fetcher.getSingleResponse(scheduledMessageUrl + "get", { id });
    }
    static deleteScheduledMessage(id) {
        return Fetcher.deleteSingleResponse(scheduledMessageUrl + "delete", {
            id,
        });
    }
    static toggleScheduledMessageActivation(id) {
        return Fetcher.postSingleResponse(scheduledMessageUrl + "/toggleActivation", { id });
    }
    static getMessageThread(threadId) {
        return Fetcher.getSingleArrayResponse(advisorUrl + `thread?threadId=${threadId}`);
    }
    static getMessageIdsInThread({ messageId, }) {
        return Fetcher.getSingleResponse("/aviso/message/messageIdsInThread", {
            messageId,
        });
    }
    static getMessage(messageId) {
        return Fetcher.getSingleResponse("/aviso/message/getMessage", {
            messageId,
        }).then(MessageDomainService.fromJSON);
    }
    static getAdvisorUnreadMessages() {
        return Fetcher.getSingleResponse(advisorUrl + "unreadMessages");
    }
    static saveScheduledMessage(request) {
        return Fetcher.postSingleResponse(scheduledMessageUrl + "save", request);
    }
    static getMessageFromEmailAddressesAsList() {
        return Fetcher.get(advisorUrl + "getMessageFromEmailAddressesAsList");
    }
    static getFroms() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const [people, fromAddresses] = yield Promise.all([
                MessageService.getMessageFromEmailAddressesAsList(),
                FromEmailAddressService.searchFromAddress({
                    isExpired: false,
                    isVerified: true,
                }),
            ]);
            const peopleFromThings = people.map((person) => getPersonCampaignFromAddressFromPerson(person));
            const emailAddressFromThings = (_a = fromAddresses.data) === null || _a === void 0 ? void 0 : _a.map((address) => getFromEmailAddressCampaignFromAddressFromFromEmailAddress(address));
            // @ts-expect-error - TS2769 - No overload matches this call.
            return peopleFromThings.concat(emailAddressFromThings);
        });
    }
    static getAllFiltersForCurrentUser(includeEveryoneFilter = true) {
        return Fetcher.getSingleResponse(filterUrl + "getAllFiltersForCurrentUser", {
            includeEveryoneFilter,
        });
    }
    static getAllFiltersForCurrentUserFilterByApp(includeEveryoneFilter = true) {
        return Fetcher.getSingleResponse(filterUrl + "getAllFiltersForCurrentUser", {
            includeEveryoneFilter,
        });
    }
    static sendEmailToPopulation(populationId, message) {
        if (populationId == null) {
            return Promise.reject("No filter id provided");
        }
        return MessageService._sendMessage({
            messageType: SEND_TO_FILTER_MESSAGE_TYPE,
            subject: message.subject,
            body: message.body,
            sendToPersonal: message.sendToPersonal,
            sendToInstitutional: message.sendToInstitutional,
            noteTypes: message.noteTypeIds,
            attachmentsIdList: message.attachmentIds,
            studentSearchPopulation: populationId,
            logMessage: message.logMessage,
            inlineAttachments: message.inlineAttachments,
            // This always resolves with a promise of an empty array.
        });
    }
    /**
     * @deprecated - use MessageThreadService.advisorReplyToThread instead
     */
    static sendEmailReplyInThread(affiliationIds, message) {
        return MessageService._sendMessage({
            messageType: SEND_TO_SELECTED_RECIPIENTS_FROM_THREAD_ID,
            toIds: affiliationIds.map((id) => ({ id })),
            subject: message.subject,
            body: message.body,
            sendToPersonal: message.sendToPersonal,
            sendToInstitutional: message.sendToInstitutional,
            noteTypes: message.noteTypeIds,
            attachmentsIdList: message.attachmentIds,
            threadId: message.threadId,
            draftId: message.draftId,
            logMessage: message.logMessage,
            inlineAttachments: message.inlineAttachments,
        });
    }
    /**
     * @deprecated - use MessageThreadService.advisorReplyToThread instead
     */
    static sendTextReplyInThread(affiliationIds, message) {
        // @ts-expect-error - TS2345 - Argument of type '{ messageType: number; toIds: { id: string; }[]; smsBody: string; sendAsSms: true; noteTypes: number[] | null | undefined; subject: string; threadId: string; draftId: string; logMessage: boolean; inlineAttachments: boolean | ... 1 more ... | undefined; }' is not assignable to parameter of type '{ messageType: number; body: string; subject: string; toIds?: { id: string; }[] | undefined; toTagIds?: string[] | undefined; toDegreeIds?: string[] | undefined; toRecipientsFromListIds?: [] | undefined; ... 14 more ...; inlineAttachments?: boolean | ... 1 more ... | undefined; }'.
        return MessageService._sendMessage({
            messageType: SEND_TO_SELECTED_RECIPIENTS_FROM_THREAD_ID,
            toIds: affiliationIds.map((id) => ({ id })),
            smsBody: message.smsBody,
            sendAsSms: true,
            noteTypes: message.noteTypeIds,
            subject: message.subject || "",
            threadId: message.threadId,
            draftId: message.draftId,
            logMessage: message.logMessage,
            inlineAttachments: message.inlineAttachments,
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'message' implicitly has an 'any' type.
    static sendMessage(message) {
        return Fetcher.post(advisorUrl + "saveMessage", message);
    }
    static sendEmailToAffiliationIds(affiliationIds, message) {
        return MessageService._sendMessage({
            // Don't spread the message object just to make absolutely sure we're only passing in the right stuff.
            messageType: SEND_TO_RECIPIENTS_IN_LIST_MESSAGE_TYPE,
            toIds: affiliationIds.map((id) => ({ id })),
            logMessage: message.logMessage,
            subject: message.subject,
            body: message.body,
            sendToPersonal: message.sendToPersonal,
            sendToInstitutional: message.sendToInstitutional,
            noteTypes: message.noteTypeIds,
            attachmentsIdList: message.attachmentIds,
            inlineAttachments: message.inlineAttachments,
        });
    }
    static sendTextToAffiliationIds(affiliationIds, message) {
        return MessageService._sendMessage({
            messageType: SEND_TO_RECIPIENTS_IN_LIST_MESSAGE_TYPE,
            toIds: affiliationIds.map((id) => ({ id })),
            smsBody: message.smsBody,
            sendAsSms: true,
            noteTypes: message.noteTypeIds,
            logMessage: message.logMessage,
            body: "",
            subject: "",
        });
    }
    static sendTextToPopulation(populationId, message) {
        if (populationId == null) {
            return Promise.reject("No filter id provided");
        }
        return MessageService._sendMessage({
            messageType: SEND_TO_FILTER_MESSAGE_TYPE,
            studentSearchPopulation: populationId,
            smsBody: message.smsBody,
            sendAsSms: true,
            noteTypes: message.noteTypeIds,
            body: "",
            subject: "",
        });
    }
    static canIUnlog(messageIds) {
        return Fetcher.getSingleResponse(baseUrl + "/canIUnlogMessages", {
            messageIds,
        });
    }
    static unlog(messageId) {
        return Fetcher.postSingleResponse(baseUrl + "/unlog", { messageId });
    }
    /**
     * A couple of things to be aware of when using this...
     * This method is meant to model the fields that are expected by advisor/saveMessage.  It's not really
     * meant to be called outside of this service, but made public just in case. Consider using a more
     * specific method like "sendMessageToAffiliationIds"... or make your own.  Here's why:
     *
     * This endpoint isn't straightforward.  Many of the options cannot be used together.
     * For example, if you set toIds = [{id :3}] and toTagIds = [3], the message will only be sent to people with the 3 tag.
     * Also, some options are only relevant to a subset of others, so they effect who this message is sent to only in certain cases.
     * It's not clear without looking at the server-side code.
     *
     * @param {object} message - message configuration object
     * @returns {Promise<string[]>} - the saved message ids
     */
    static _sendMessage(message) {
        // Some parameters need to provided (even if empty) to the saveMessage endpoint.  While they are optional in
        // the signature of this method, we need to make sure we send them if they're not provided.
        // We also calculate sendAsNote from whether any note types are passed in.
        const fieldsThatNeedToBeDefined = {
            toIds: [],
            toTagIds: [],
            toDegreeIds: [],
            toProgramIds: [],
            toRecipientsFromListIds: [],
            toRiskLevelIds: [],
            includeSubscribers: false,
            threadId: "",
        };
        const overriddenProperties = {
            sendAsNote: !!(message.noteTypes && message.noteTypes.length),
            // Note types need to be objects with an id property
            noteTypes: (message.noteTypes || []).map((type) => ({ id: type })),
        };
        return Fetcher.post(advisorUrl + "saveMessage", Object.assign(Object.assign(Object.assign({}, fieldsThatNeedToBeDefined), message), overriddenProperties));
    }
    static log(messageId) {
        return Fetcher.postSingleResponse(baseUrl + "/log", { messageId });
    }
    static canILogMessages() {
        return Fetcher.getSingleResponse(baseUrl + "/canILogMessages");
    }
    static sendEmailToOpportunities(opportunityIds, message, options = {}) {
        return MessageService._sendToOpportunities({
            opportunityIds,
            subject: message.subject,
            body: message.body,
            sendToInstitutionalEmail: message.sendToInstitutional,
            sendToPersonalEmail: message.sendToPersonal,
            noteTypeIds: options.noteTypeIds,
            attachmentIds: message.attachmentIds,
            logMessage: options.logMessage,
            inlineAttachments: options.inlineAttachments,
        });
    }
    static sendTextToOpportunities(opportunityIds, message, options = {}) {
        return MessageService._sendToOpportunities({
            opportunityIds,
            sendAsSms: true,
            smsBody: message.smsBody,
            noteTypeIds: options.noteTypeIds,
            logMessage: options.logMessage,
        });
    }
    /**
     * @private
     */
    static _sendToOpportunities({ opportunityIds, subject, sendAsSms, smsBody, body, fromPersonId, noteTypeIds, messageType, sourceId, sendToInstitutionalEmail, sendToPersonalEmail, logMessage, attachmentIds, inlineAttachments, }) {
        return Fetcher.postSingleResponse(baseUrl + "/sendToOpportunities", {
            opportunityIds,
            subject,
            sendAsSms,
            smsBody,
            body,
            fromPersonId,
            noteTypeIds,
            messageType,
            sourceId,
            sendToInstitutionalEmail,
            sendToPersonalEmail,
            logMessage,
            attachmentIds,
            inlineAttachments,
        });
    }
    static sendEmailToPersonPopulation(populationId, message, options = {}) {
        return MessageService._sendToPersonPopulation({
            populationId,
            subject: message.subject,
            body: message.body,
            sendToInstitutionalEmail: message.sendToInstitutional,
            sendToPersonalEmail: message.sendToPersonal,
            noteTypeIds: options.noteTypeIds,
            attachmentIds: message.attachmentIds,
            logMessage: options.logMessage,
            inlineAttachments: options.inlineAttachments,
        });
    }
    static sendTextToPersonPopulation(populationId, message, options = {}) {
        return MessageService._sendToPersonPopulation({
            populationId,
            sendAsSms: true,
            smsBody: message.smsBody,
            noteTypeIds: options.noteTypeIds,
            logMessage: options.logMessage,
        });
    }
    static _sendToPersonPopulation({ populationId, subject, sendAsSms, smsBody, body, fromPersonId, noteTypeIds, messageType, sourceId, sendToInstitutionalEmail, sendToPersonalEmail, logMessage, attachmentIds, inlineAttachments, }) {
        return Fetcher.postSingleResponse(baseUrl + "/sendToPersonPopulation", {
            populationId,
            subject,
            sendAsSms,
            smsBody,
            body,
            fromPersonId,
            noteTypeIds,
            messageType,
            sourceId,
            sendToInstitutionalEmail,
            sendToPersonalEmail,
            logMessage,
            attachmentIds,
            inlineAttachments,
        });
    }
}
